interface BaseElement {
  id: string
  size: number
}

export interface ContainerElement<T extends DashboardElement = DashboardElement> extends BaseElement {
  type: 'container'
  direction: 'horizontal' | 'vertical'
  children: T[]
}

export interface SlotElement extends BaseElement {
  type: 'slot'
  componentType: ComponentType
}

export const isContainer = (element: DashboardElement): element is ContainerElement => {
  return element.type === 'container'
}

export const isSlot = (element: DashboardElement): element is SlotElement => {
  return element.type === 'slot'
}

export const isGhost = (element: DashboardElement): element is SlotElement => {
  return isSlot(element) && element.componentType.includes('ghost')
}

export type DashboardElement = ContainerElement | SlotElement

export interface DashboardComponent {
  id: string
  type: ComponentType
  title: string
}

export type ComponentType =
  | string
  | 'tickets'
  | 'secureScores'
  | 'azure'
  | 'keyContacts'
  | 'expiringLicenses'
  | 'autoRenewingLicenses'
  | 'awaitingActionTickets'
  | 'closedTickets'
  | 'awaitingResponseTickets'
  | 'openTickets'
  | 'recentFiles'
  | 'ticketsByPriority'
  | 'ticketsByStatus'
  | 'azureTotalEmissions'
  | 'recentAzureDeployments'
  | 'quickLinks'
  | 'quickActions'
  | 'completedChanges'
  | 'upcomingChanges'
  | 'azureYearToDate'
  | 'azureMonthToDate'

export interface DashboardStructure {
  layout: ContainerElement
  components: Record<string, DashboardComponent>
}
